module.exports = __webpack_public_path__ + "static/FluxibleHeaderLogo@2x-c52be2fb1e61a7cc1280073598cfe809.png";